import { NameResourceItem } from "../NameResourceItem";
import { createListResource } from "../../list";

export type Czcionka = NameResourceItem;

export const czcionkaResource = createListResource<Czcionka>("plm/czcionki/");
